import {
    AbstractControl,
    AsyncValidatorFn,
    UntypedFormArray,
    UntypedFormControl,
    UntypedFormGroup,
    ValidatorFn,
} from "@angular/forms";

export class SigncoFormGroup extends UntypedFormGroup {
    submitted: boolean;
    validating: boolean;

    constructor(
        controls: { [key: string]: AbstractControl },
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | null,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
    ) {
        super(controls, validatorOrOpts, asyncValidator);
    }

    override get(path: Array<string | number> | string): SigncoFormControl {
        return super.get(path) as SigncoFormControl;
    }

    getFormGroup(path: Array<string | number> | string): SigncoFormGroup {
        return super.get(path) as SigncoFormGroup;
    }

    getFormArray(path: Array<string | number> | string): SigncoFormArray {
        return super.get(path) as SigncoFormArray;
    }
}

export class SigncoFormControl extends UntypedFormControl {
    errorMessages: string[];
    showErrors: boolean;
    hidden: boolean;
}

export class SigncoFormArray extends UntypedFormArray {
    showErrors: boolean;

    constructor(
        controls: AbstractControl[],
        validatorOrOpts?: ValidatorFn | ValidatorFn[] | null,
        asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null,
    ) {
        super(controls, validatorOrOpts, asyncValidator);
    }

    getControls(): SigncoFormGroup[] {
        return this.controls.map((x) => x as SigncoFormGroup);
    }
}
